import React from "react";

interface NoDataMessageProps {
  message: string;
  allZero?: boolean;
}

const NoDataMessage: React.FC<NoDataMessageProps> = ({ message, allZero = false }) => {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
      {/* Enhanced background effects */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-gray-50 rounded-full opacity-60"></div>
        <div className="absolute w-32 h-32 bg-blue-500/5 rounded-full blur-xl"></div>
      </div>

      {/* Enhanced icon container */}
      <div className="relative w-24 h-24 bg-gray-200/50 rounded-full border-2 border-gray-300/60 border-dashed flex items-center justify-center mb-4">
        {allZero ? (
          <span className="text-4xl font-light text-gray-400">0</span>
        ) : (
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
        )}
      </div>

      {/* Message with better styling for longer text */}
      <p className="text-sm text-gray-500 font-medium relative z-10 text-center max-w-[200px] px-4">{allZero ? "All values are zero" : message}</p>
    </div>
  );
};

export default NoDataMessage;
